import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "product-teaser-wide__img-wrapper" }
const _hoisted_2 = ["href", "aria-label"]
const _hoisted_3 = { class: "product-teaser-wide__img-wrapper" }
const _hoisted_4 = { class: "product-teaser-wide__box-top" }
const _hoisted_5 = ["href"]
const _hoisted_6 = ["href"]
const _hoisted_7 = { class: "product-teaser-wide__header | headline headline--type_h2" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { class: "product-teaser-wide__conversion" }
const _hoisted_10 = {
  key: 0,
  class: "product-teaser__zero-price-wrapper"
}
const _hoisted_11 = { class: "product-teaser__button-container" }
const _hoisted_12 = { class: "product-box__status product-box__status--unavailable" }
const _hoisted_13 = ["href", "innerHTML"]
const _hoisted_14 = {
  key: 1,
  class: "product-teaser-wide__price-wrapper"
}
const _hoisted_15 = { class: "product-teaser-wide__price" }
const _hoisted_16 = { class: "product-teaser-wide__button-container" }
const _hoisted_17 = ["href", "innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_image_element = _resolveComponent("image-element")!
  const _component_ratings = _resolveComponent("ratings")!
  const _component_price_info = _resolveComponent("price-info")!
  const _component_availability_info = _resolveComponent("availability-info")!
  const _component_product_qty_and_cart_btn = _resolveComponent("product-qty-and-cart-btn")!

  return (_ctx.product)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(_ctx.productTeaserWideClass)
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("a", {
            class: _normalizeClass(["product-teaser-wide__link", {
          'product-teaser-wide--product-image': _ctx.productSrc
        }]),
            href: _ctx.product.url,
            "aria-label": _ctx.headlineText
          }, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_image_element, {
                "img-class": "product-teaser-wide__img",
                src: [_ctx.image || _ctx.productSrc],
                alt: _ctx.headlineText,
                title: _ctx.headlineText
              }, null, 8 /* PROPS */, ["src", "alt", "title"])
            ])
          ], 10 /* CLASS, PROPS */, _hoisted_2)
        ]),
        _cache[8] || (_cache[8] = _createTextVNode()),
        _createElementVNode("div", {
          class: _normalizeClass(["product-teaser-wide__box", {
        'product-teaser-wide--in-basket': _ctx.product.inBasket
      }])
        }, [
          _createElementVNode("div", _hoisted_4, [
            (!_ctx.product.inBasket)
              ? (_openBlock(), _createBlock(_component_ratings, {
                  key: 0,
                  class: "product-teaser-wide__ratings",
                  rating: _ctx.product.ratings,
                  type: "disabled"
                }, null, 8 /* PROPS */, ["rating"]))
              : (_openBlock(), _createElementBlock("a", {
                  key: 1,
                  class: "product-box__status product-box__status--basket product-box__status--basket-up",
                  href: _ctx.basketUrl
                }, _toDisplayString(_ctx.$t('ads.ads_top_info.article_in_basket')), 9 /* TEXT, PROPS */, _hoisted_5)),
            _cache[1] || (_cache[1] = _createTextVNode()),
            _createElementVNode("a", {
              class: "product-teaser-wide__link",
              href: _ctx.product.url
            }, [
              _createElementVNode("header", _hoisted_7, _toDisplayString(_ctx.headlineText), 1 /* TEXT */)
            ], 8 /* PROPS */, _hoisted_6),
            _cache[2] || (_cache[2] = _createTextVNode()),
            _createElementVNode("div", {
              class: "product-teaser-wide__subline",
              innerHTML: _ctx.subline || _ctx.product.shortDescription
            }, null, 8 /* PROPS */, _hoisted_8)
          ]),
          _cache[7] || (_cache[7] = _createTextVNode()),
          _createElementVNode("div", _hoisted_9, [
            (_ctx.product.zeroPriceItem)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t('availability.no-price')), 1 /* TEXT */)
                  ]),
                  _cache[3] || (_cache[3] = _createTextVNode()),
                  (_ctx.product.showFoodSpecificationLink)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        class: "product-teaser-wide__specification-link",
                        href: _ctx.foodSpecificationLink,
                        innerHTML: _ctx.$t('detail.product.characteristics')
                      }, null, 8 /* PROPS */, _hoisted_13))
                    : _createCommentVNode("v-if", true)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    (!_ctx.isOnRequestWithoutPrice(_ctx.product.purchaseOnRequestArticle))
                      ? (_openBlock(), _createBlock(_component_price_info, {
                          key: 0,
                          value: _ctx.product.price,
                          "show-star": !_ctx.settings.price.showTax,
                          "show-tax": _ctx.settings.price.showTax
                        }, null, 8 /* PROPS */, ["value", "show-star", "show-tax"]))
                      : _createCommentVNode("v-if", true)
                  ]),
                  _cache[6] || (_cache[6] = _createTextVNode()),
                  _createElementVNode("div", _hoisted_16, [
                    (_ctx.showAvailability)
                      ? (_openBlock(), _createBlock(_component_availability_info, {
                          key: 0,
                          class: "product-box__availability",
                          availability: _ctx.product.availability
                        }, null, 8 /* PROPS */, ["availability"]))
                      : _createCommentVNode("v-if", true),
                    _cache[4] || (_cache[4] = _createTextVNode()),
                    _createVNode(_component_product_qty_and_cart_btn, {
                      "product-data": _ctx.product,
                      "product-link": _ctx.product.url,
                      state: _ctx.state,
                      "cart-button-text": _ctx.$t('productteaser.addToCart'),
                      "recurring-buyable": true,
                      "cart-button-class": "product-teaser-wide__cart-btn",
                      onQuantityChange: _ctx.counterChangeHandler,
                      onAddToBasket: _ctx.addToBasket,
                      onOnRequestClicked: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openOnRequestLightBox()))
                    }, null, 8 /* PROPS */, ["product-data", "product-link", "state", "cart-button-text", "onQuantityChange", "onAddToBasket"]),
                    _cache[5] || (_cache[5] = _createTextVNode()),
                    (_ctx.product.showFoodSpecificationLink)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 1,
                          class: "product-teaser-wide__specification-link",
                          href: _ctx.foodSpecificationLink,
                          innerHTML: _ctx.$t('detail.product.characteristics')
                        }, null, 8 /* PROPS */, _hoisted_17))
                      : _createCommentVNode("v-if", true)
                  ])
                ]))
          ])
        ], 2 /* CLASS */)
      ], 2 /* CLASS */))
    : _createCommentVNode("v-if", true)
}